import { useEffect, useState } from "react"
import { useDetailContext } from "../DetailContext";
import { ActionName, EventCallbackParamsType, MockupObject } from "../MockupEditor"
import CustomImage from "components/common/CustomImage";

type Pos = {
    x: number,
    y: number,
    w: number,
    h: number
}

export default function ElementTips(props: { title ?: string, gif ?: string, type ?: string}){
    const detailContext = useDetailContext();
    const { title = 'Please click on the area where you want to change the color.',
        gif = '/case/icon-smart-color.gif', type = 'color' } = props ;

    const [ pos, setPos] = useState<Pos>();
    const [ isShow, setIsShow ] = useState<boolean>(true);

    useEffect(() => {
        const lskey = type + '-tip';
        const currCount = +(localStorage.getItem(lskey) || 0)
        if(currCount > 2){
            setIsShow(false);
            return setPos(undefined)
        }
        localStorage.setItem(lskey, `${currCount + 1}`);
    },[])

    // 处理编辑器相关的回调
    useEffect(() => {  
        if(!isShow){
            return setPos(undefined)
        }

        const detype = detailContext?.editorCallbackData?.type ;
        switch(detype){
            case EventCallbackParamsType.GET_SELECTED_OBJECT_DATA_CALLBACK:
                const data = detailContext?.editorCallbackData?.data as MockupObject ;
                setPos({
                    x: data.globalLeft,
                    y: data.globalTop,
                    w: data.globalWidth,
                    h: data.globalHeight
                })
                break;
            case EventCallbackParamsType.SMART_COLOR_AI_READY:
            case EventCallbackParamsType.MOCKUP_AI_AREA_READY:
                detailContext?.triggerEditorAction({
                    name : ActionName.GET_SELECTED_OBJECT_DATA,
                })
                break;
        }
    },[detailContext?.editorCallbackData])

    const confirm = () => {
        setPos(undefined)
    }


    return (
        <>
            {
                pos &&
                <div className="fixed z-[1301] shadow-box translate-x-[-50%]  translate-y-[-50%] p-[20px] rounded-[10px] bg-[#FFFFFF]" style={{
                    width: 400,
                    left: pos.x + pos.w / 2,
                    top: pos.y + pos.h / 2
                }}>
                    <p>{title}</p>
                    <CustomImage src={gif} className="w-full mt-[15px]"/>
                    <span className="cursor-pointer mt-[15px] py-[8px] block text-center border border-[#D9D9D9] rounded-[10px]"
                        onClick={confirm}>OK</span>
                </div>
            }
        </>
    )
}